import { render, staticRenderFns } from "./banner-card.vue?vue&type=template&id=75150338&scoped=true&"
import script from "./banner-card.vue?vue&type=script&lang=js&"
export * from "./banner-card.vue?vue&type=script&lang=js&"
import style0 from "./banner-card.vue?vue&type=style&index=0&id=75150338&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75150338",
  null
  
)

export default component.exports